import React, { useState, useEffect } from 'react';
import {
  Card,
  Row,
  Col,
  Table,
  Tag,
  Button,
  Statistic,
  Modal,
  Form,
  Input,
  Select,
  message,
  Space,
  Badge,
  Descriptions,
  Tabs,
  Avatar,
  Layout,
  Tooltip,
  Typography,
  Collapse,
  Spin,
  Alert,
  Divider,
  Dropdown,
  Grid
} from 'antd';
import {
  FileDoneOutlined,
  EyeOutlined,
  SendOutlined,
  AlertOutlined,
  UserOutlined,
  TeamOutlined,
  CrownOutlined,
  CalendarOutlined,
  ArrowRightOutlined,
  InfoCircleOutlined,
  DatabaseOutlined,
  FileTextOutlined,
  DownOutlined,
  CloseOutlined,
  BarsOutlined,
  CheckOutlined,
  StopOutlined,
  RiseOutlined,
  PartitionOutlined,
  EnvironmentOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  ClockCircleOutlined,
  ReloadOutlined,
  ArrowLeftOutlined,
  ThunderboltOutlined
} from '@ant-design/icons';
import axios from 'axios';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Navbar from "./Navbar";
// import Sidebar from "./Sidebar";

const { Content } = Layout;
const { Title, Text } = Typography;
const { useBreakpoint } = Grid;
const API_BASE = process.env.REACT_APP_API_BASE_URL + '/api';

const api = axios.create({
  baseURL: API_BASE
});

api.interceptors.request.use(config => {
  const token = sessionStorage.getItem('token');
  const userRole = sessionStorage.getItem('userRole') || 'ULB';
  const userId = sessionStorage.getItem('userId');
  
  const userDivision = sessionStorage.getItem('division_id') || sessionStorage.getItem('division');
  const userDistrict = sessionStorage.getItem('district_id') || sessionStorage.getItem('district');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  config.headers['x-user-role'] = userRole;
  
  if (userId && userId !== 'null' && userId !== 'undefined') {
    config.headers['x-user-id'] = userId;
  }
  
  if (userDivision && userDivision !== 'null' && userDivision !== 'undefined' && userDivision !== '') {
    config.headers['x-user-division'] = userDivision;
  }
  
  if (userDistrict && userDistrict !== 'null' && userDistrict !== 'undefined' && userDistrict !== '') {
    config.headers['x-user-district'] = userDistrict;
  }

  return config;
}, error => {
  return Promise.reject(error);
});

const FormInstancesView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { formId } = useParams();
  const { formName, viewType: initialViewType, viewContext: initialViewContext } = location.state || {};
  
  const screens = useBreakpoint();
  const [sbCollapsed, setSbCollapsed] = useState(() => {
    const saved = sessionStorage.getItem("sidebar_collapsed");
    return saved ? JSON.parse(saved) : false;
  });
  
  const [loading, setLoading] = useState(false);
  const [loadingFormData, setLoadingFormData] = useState(false);
  const [loadingSchema, setLoadingSchema] = useState(false);
  const [instances, setInstances] = useState([]);
  const [schemaFields, setSchemaFields] = useState([]);
  const [fieldMapping, setFieldMapping] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [userInfo, setUserInfo] = useState({ 
    id: null, 
    name: '', 
    role: '', 
    roleType: 'ULB',
    isSuperAdmin: false,
    isDMAAdmin: false,
    isDivisionalOfficer: false,
    isDistrictAdmin: false,
    isULBUser: false,
    canViewAll: false,
    canViewDivision: false,
    canViewDistrict: false,
    canViewOwn: true,
    canActionOwn: false,
    canActionSubordinate: false,
    canActionDistrict: false,
    canActionDivision: false
  });
  
  const [summary, setSummary] = useState({
    total: 0,
    own_submissions: 0,
    ulb_submissions: 0,
    dao_submissions: 0,
    actionable: 0
  });
  
  const [bulkActionModal, setBulkActionModal] = useState({ 
    visible: false, 
    selectedCount: 0,
    selectedInstances: [],
    action: null
  });
  
  const [bulkActionForm] = Form.useForm();
  const [districtCache, setDistrictCache] = useState({});
  const [divisionCache, setDivisionCache] = useState({});
  
  // ===== NEW: Auto-refresh state =====
  const [lastUpdated, setLastUpdated] = useState(Date.now());
  const [autoRefreshEnabled, setAutoRefreshEnabled] = useState(true);
  const [countdown, setCountdown] = useState(5);

  // Responsive calculations
  const isMobile = !screens.md;
  const sidebarWidth = sbCollapsed ? 80 : 260;
  const mainContentWidth = `calc(100% - ${sidebarWidth}px)`;

  // Load user info on mount
  useEffect(() => {
    const userStr = sessionStorage.getItem('user');
    const user = userStr ? JSON.parse(userStr) : {};
    
    const userId = sessionStorage.getItem('userId') || user.id || null;
    const userRole = sessionStorage.getItem('userRole') || user.workflow_role || user.role_name || 'ULB';
    const userName = sessionStorage.getItem('userName') || user.username || user.name || 'User';
    
    const userDivisionId = sessionStorage.getItem('division_id') || sessionStorage.getItem('division') || user.division_id || user.division || '';
    const userDistrictId = sessionStorage.getItem('district_id') || sessionStorage.getItem('district') || user.district_id || user.district || '';
    
    let roleType = 'ULB';
    let isSuperAdmin = false;
    let isDMAAdmin = false;
    let isDivisionalOfficer = false;
    let isDistrictAdmin = false;
    let isULBUser = false;
    
    const roleUpper = userRole.toUpperCase();
    
    // ✅ FIX: DMA role योग्यरित्या ओळखा
    if (roleUpper === 'ADMIN' || roleUpper === 'SUPER_ADMIN' || roleUpper === 'SUPERADMIN') {
      roleType = 'ADMIN';
      isSuperAdmin = true;
    } 
    // ✅ DMA role - सर्व DMA संबंधित roles
    else if (roleUpper === 'DMA_DESK_OFFICER' || 
             roleUpper === 'DMA' || 
             roleUpper === 'DMA_ADMIN' || 
             roleUpper === 'DMAOFFICER' ||
             roleUpper === 'DIRECTORATE' ||
             roleUpper.includes('DMA')) {
      roleType = 'DMA_DESK_OFFICER';
      isDMAAdmin = true;
    } 
    else if (roleUpper === 'DIVISIONAL_OFFICER' || 
             roleUpper === 'DIVISIONALOFFICER' || 
             roleUpper === 'RDMA' || 
             roleUpper === 'DIVISIONAL') {
      roleType = 'DIVISIONAL_OFFICER';
      isDivisionalOfficer = true;
    } 
    else if (roleUpper === 'DAO' || 
             roleUpper === 'DISTRICT_ADMIN' || 
             roleUpper === 'DISTRICTADMIN') {
      roleType = 'DAO';
      isDistrictAdmin = true;
    } 
    else {
      roleType = 'ULB';
      isULBUser = true;
    }

    const canViewAll = isSuperAdmin || isDMAAdmin;
    const canViewDivision = isDivisionalOfficer || isSuperAdmin || isDMAAdmin;
    const canViewDistrict = isDistrictAdmin || isDivisionalOfficer || isSuperAdmin || isDMAAdmin;
    
    const canActionOwn = false;
    const canActionDistrict = isDistrictAdmin || isDivisionalOfficer || isDMAAdmin || isSuperAdmin;
    const canActionDivision = isDivisionalOfficer || isDMAAdmin || isSuperAdmin;
    const canActionSubordinate = isDistrictAdmin || isDivisionalOfficer || isDMAAdmin || isSuperAdmin;

    setUserInfo({
      id: userId,
      name: userName,
      role: userRole,
      roleType: roleType,
      division: userDivisionId,
      district: userDistrictId,
      division_id: userDivisionId,
      district_id: userDistrictId,
      isSuperAdmin,
      isDMAAdmin,
      isDivisionalOfficer,
      isDistrictAdmin,
      isULBUser,
      canViewAll,
      canViewDivision,
      canViewDistrict,
      canViewOwn: true,
      canActionOwn,
      canActionDistrict,
      canActionDivision,
      canActionSubordinate
    });
  }, []);

  // Listen for sidebar state changes
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "sidebar_collapsed") {
        const newValue = e.newValue ? JSON.parse(e.newValue) : false;
        setSbCollapsed(newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    const interval = setInterval(() => {
      const saved = sessionStorage.getItem("sidebar_collapsed");
      if (saved !== null) {
        const parsed = JSON.parse(saved);
        if (parsed !== sbCollapsed) {
          setSbCollapsed(parsed);
        }
      }
    }, 500);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [sbCollapsed]);

  // ===== NEW: रिअल-टाइम अपडेटसाठी इव्हेंट लिसनर =====
  useEffect(() => {
    const handleWorkflowUpdate = (e) => {
      if (e.key === 'workflow_updated' || e.key === 'new_submission') {
        console.log('🔄 Workflow updated event received, reloading data...');
        setLastUpdated(Date.now());
        loadFormInstances();
        loadFormSchema();
      }
    };

    const handleCustomEvent = () => {
      console.log('🔄 Custom workflow update event received');
      setLastUpdated(Date.now());
      loadFormInstances();
      loadFormSchema();
    };

    window.addEventListener('storage', handleWorkflowUpdate);
    window.addEventListener('workflow-updated', handleCustomEvent);
    window.addEventListener('form-submitted', handleCustomEvent);

    return () => {
      window.removeEventListener('storage', handleWorkflowUpdate);
      window.removeEventListener('workflow-updated', handleCustomEvent);
      window.removeEventListener('form-submitted', handleCustomEvent);
    };
  }, [formId]);

  // ===== NEW: फास्ट रिफ्रेश इंटरव्हल =====
  useEffect(() => {
    if (!formId || !autoRefreshEnabled) return;

    // पहिल्या 2 सेकंदात लोड करा
    const initialTimer = setTimeout(() => {
      console.log('🔄 Initial data load');
      loadFormInstances();
      loadFormSchema();
    }, 500);

    // काउंटडाउन इंटरव्हल
    const countdownInterval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          return 5;
        }
        return prev - 1;
      });
    }, 1000);

    // दर 5 सेकंदांनी रिफ्रेश करा (झटपट अपडेटसाठी)
    const fastInterval = setInterval(() => {
      console.log('⚡ Auto-refresh - checking for new submissions');
      loadFormInstances();
      setLastUpdated(Date.now());
    }, 5000); // 5 seconds

    // नॉर्मल इंटरव्हल (बॅकअप)
    const normalInterval = setInterval(() => {
      loadFormInstances();
    }, 30000);

    return () => {
      clearTimeout(initialTimer);
      clearInterval(countdownInterval);
      clearInterval(fastInterval);
      clearInterval(normalInterval);
    };
  }, [formId, autoRefreshEnabled]);

  // ===== NEW: फोर्स रिफ्रेश फंक्शन =====
  const forceRefresh = async () => {
    console.log('⚡ Force refresh triggered');
    setLoading(true);
    
    try {
      await Promise.all([
        loadFormInstances(),
        loadFormSchema()
      ]);
      
      // नोटिफिकेशन ट्रिगर करा
      sessionStorage.setItem('workflow_updated', Date.now().toString());
      window.dispatchEvent(new CustomEvent('workflow-updated'));
      setLastUpdated(Date.now());
      
      message.success('Data refreshed successfully');
    } catch (error) {
      console.error('Force refresh failed:', error);
      message.error('Failed to refresh data');
    } finally {
      setLoading(false);
    }
  };

  // Fetch district name by ID
  const fetchDistrictName = async (districtId) => {
    if (!districtId || districtId === 'null' || districtId === 'undefined' || districtId === '') {
      return districtId;
    }
    
    if (districtCache[districtId]) {
      return districtCache[districtId];
    }
    
    try {
      const cachedDistricts = JSON.parse(sessionStorage.getItem('districtCache') || '{}');
      if (cachedDistricts[districtId]) {
        setDistrictCache(prev => ({ ...prev, [districtId]: cachedDistricts[districtId] }));
        return cachedDistricts[districtId];
      }
      
      const response = await api.get(`/district/${districtId}`);
      if (response.data && response.data.success) {
        const districtName = response.data.data?.name || 
                            response.data.data?.district_name || 
                            response.data.data?.district || 
                            `District ${districtId}`;
        
        const newCache = { ...cachedDistricts, [districtId]: districtName };
        sessionStorage.setItem('districtCache', JSON.stringify(newCache));
        setDistrictCache(prev => ({ ...prev, [districtId]: districtName }));
        
        return districtName;
      }
      return `District ${districtId}`;
    } catch (error) {
      console.error(`Failed to fetch district name for ID ${districtId}:`, error);
      return `District ${districtId}`;
    }
  };

  // Fetch division name by ID
  const fetchDivisionName = async (divisionId) => {
    if (!divisionId || divisionId === 'null' || divisionId === 'undefined' || divisionId === '') {
      return divisionId;
    }
    
    if (divisionCache[divisionId]) {
      return divisionCache[divisionId];
    }
    
    try {
      const cachedDivisions = JSON.parse(sessionStorage.getItem('divisionCache') || '{}');
      if (cachedDivisions[divisionId]) {
        setDivisionCache(prev => ({ ...prev, [divisionId]: cachedDivisions[divisionId] }));
        return cachedDivisions[divisionId];
      }
      
      const response = await api.get(`/division/${divisionId}`);
      if (response.data && response.data.success) {
        const divisionName = response.data.data?.name || 
                            response.data.data?.division_name || 
                            response.data.data?.division || 
                            `Division ${divisionId}`;
        
        const newCache = { ...cachedDivisions, [divisionId]: divisionName };
        sessionStorage.setItem('divisionCache', JSON.stringify(newCache));
        setDivisionCache(prev => ({ ...prev, [divisionId]: divisionName }));
        
        return divisionName;
      }
      return `Division ${divisionId}`;
    } catch (error) {
      console.error(`Failed to fetch division name for ID ${divisionId}:`, error);
      return `Division ${divisionId}`;
    }
  };

  const canUserTakeAction = (record) => {
    if (record.can_take_action !== undefined) {
      return record.can_take_action;
    }
    
    if (record.stage_status !== 'in_progress') {
      return false;
    }
    
    if (userInfo.isSuperAdmin || userInfo.isDMAAdmin) {
      return true;
    }
    
    if (userInfo.isULBUser) {
      return String(record.submitted_by_id) === String(userInfo.id);
    }
    
    if (userInfo.isDistrictAdmin) {
      const isOwnSubmission = String(record.submitted_by_id) === String(userInfo.id);
      const isULBSubmission = !isOwnSubmission && 
        (record.submitted_by_role === 'ULB' || 
         record.submitted_by_role === 'ulb' || 
         record.submitted_by_role === 'User' ||
         record.submitted_by_role === 'user' ||
         !record.submitted_by_role);
      
      return isULBSubmission && !isOwnSubmission;
    }
    
    if (userInfo.isDivisionalOfficer) {
      const isOwnSubmission = String(record.submitted_by_id) === String(userInfo.id);
      const isActionableRole = !isOwnSubmission &&
        (record.submitted_by_role === 'ULB' || 
         record.submitted_by_role === 'ulb' || 
         record.submitted_by_role === 'User' ||
         record.submitted_by_role === 'user' ||
         record.submitted_by_role === 'DAO' ||
         record.submitted_by_role === 'DistrictAdmin' ||
         record.submitted_by_role === 'district_admin' ||
         !record.submitted_by_role);
      
      return isActionableRole && !isOwnSubmission;
    }
    
    return false;
  };

  const canUserViewSubmission = (record) => {
  // Super Admin and DMA Admin can view all
  if (userInfo.isSuperAdmin || userInfo.isDMAAdmin) {
    return true;
  }
  
  // Divisional Officer - फक्त आपल्या division मधील
  if (userInfo.isDivisionalOfficer) {
    const submissionDivision = String(record.division_id || record.division || '').trim();
    const userDivision = String(userInfo.division_id || userInfo.division || '').trim();
    return submissionDivision === userDivision;
  }
  
  // District Admin - फक्त आपल्या district मधील
  if (userInfo.isDistrictAdmin) {
    const submissionDistrict = String(record.district_id || record.district || '').trim();
    const userDistrict = String(userInfo.district_id || userInfo.district || '').trim();
    return submissionDistrict === userDistrict;
  }
  
  // ✅ ULB User - फक्त स्वतःचे submissions पाहू शकतो
  if (userInfo.isULBUser) {
    return String(record.submitted_by_id) === String(userInfo.id);
  }
  
  return false;
};

  // Load form schema fields from backend
  const loadFormSchema = async () => {
    try {
      setLoadingSchema(true);
      console.log(`📋 Loading form schema for form ID: ${formId}`);
      
      const response = await api.get(`/workflow/form-schema-fields/${formId}`);
      
      if (response.data.success && response.data.data) {
        const fields = response.data.data;
        console.log(`✅ Loaded ${fields.length} schema fields:`, fields);
        
        setSchemaFields(fields);
        
        // Build field mapping for quick lookup
        const mapping = {};
        fields.forEach(field => {
          // Map by field_id
          if (field.field_id) {
            mapping[field.field_id] = {
              label: field.label || field.field_id,
              marathi_label: field.marathi_label || field.label,
              type: field.type || 'text',
              required: field.required || false
            };
          }
          // Also map by id
          if (field.id) {
            mapping[field.id.toString()] = {
              label: field.label || `Field ${field.id}`,
              marathi_label: field.marathi_label || field.label,
              type: field.type || 'text',
              required: field.required || false
            };
          }
          // Map by name if different
          if (field.name && field.name !== field.field_id) {
            mapping[field.name] = mapping[field.field_id];
          }
        });
        
        setFieldMapping(mapping);
        console.log('✅ Field mapping created:', mapping);
      }
    } catch (error) {
      console.error('❌ Failed to load form schema:', error);
      message.error('Failed to load form fields: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoadingSchema(false);
    }
  };

  const loadFormInstances = async () => {
    try {
      setLoading(true);
      setLoadingFormData(true);

      const viewType = initialViewType || getViewTypeForNavigation();
      const viewContext = initialViewContext || getViewContextForNavigation();

      let endpoint = '';
      if (viewType === 'admin') {
        endpoint = `/workflow/admin/instances-by-form/${formId}`;
      } else if (viewType === 'division') {
        endpoint = `/workflow/division/${viewContext || ''}/instances-by-form/${formId}`;
      } else if (viewType === 'district') {
        endpoint = `/workflow/district/${viewContext || ''}/instances-by-form/${formId}`;
      } else {
        endpoint = `/workflow/user/${viewContext}/instances-by-form/${formId}`;
      }

      console.log(`📋 Loading instances from: ${endpoint}`);
      const instancesRes = await api.get(endpoint);
      
      let instancesData = instancesRes.data.data || [];
      
      // Set can_take_action flag
      instancesData = instancesData.map(instance => ({
        ...instance,
        can_take_action: instance.can_take_action !== undefined 
          ? instance.can_take_action 
          : canUserTakeAction(instance)
      }));
      
      // Fetch detailed form data for each instance to get field values
      const enhancedInstances = instancesData.length > 0 ? await Promise.all(instancesData.map(async (instance) => {
        try {
          // Fetch district name if it's an ID
          let districtDisplay = instance.district;
          if (instance.district && !isNaN(instance.district) && instance.district.toString().length < 10) {
            districtDisplay = await fetchDistrictName(instance.district);
          }
          
          // Fetch division name if it's an ID
          let divisionDisplay = instance.division;
          if (instance.division && !isNaN(instance.division) && instance.division.toString().length < 10) {
            divisionDisplay = await fetchDivisionName(instance.division);
          }
          
          // Fetch full form data with field values
          const formDataRes = await api.get(`/workflow/form-data`, {
            params: {
              instance_id: instance.instance_id,
              submission_id: instance.submission_id,
              form_id: formId
            }
          });
          
          const result = formDataRes.data.data;
          
          // Extract field values from the response
          let fieldValues = {};
          
          // Try to get from mapped_form_data first
          if (result && result.mapped_form_data) {
            Object.keys(result.mapped_form_data).forEach(key => {
              const fieldData = result.mapped_form_data[key];
              if (fieldData && typeof fieldData === 'object') {
                if (fieldData.value !== undefined) {
                  fieldValues[key] = fieldData.value;
                } else {
                  fieldValues[key] = fieldData;
                }
              } else {
                fieldValues[key] = fieldData;
              }
            });
          }
          
          // Then try parsed_form_data
          if (result && result.parsed_form_data) {
            fieldValues = { ...fieldValues, ...result.parsed_form_data };
          }
          
          // Then try submission_data
          if (result && result.submission_data) {
            // Filter out metadata fields
            const metadataFields = ['id', 'form_id', 'submission_id', 'created_at', 'updated_at', 'status', 'submitted_by'];
            Object.keys(result.submission_data).forEach(key => {
              if (!metadataFields.includes(key) && !fieldValues[key]) {
                fieldValues[key] = result.submission_data[key];
              }
            });
          }
          
          console.log(`📋 Field values for instance ${instance.instance_id}:`, fieldValues);
          
          return {
            ...instance,
            ...fieldValues,
            district: districtDisplay,
            division: divisionDisplay,
            district_id: instance.district,
            division_id: instance.division
          };
        } catch (error) {
          console.error(`Failed to load form data for instance ${instance.instance_id}:`, error);
          
          // Still try to fetch district/division names
          let districtDisplay = instance.district;
          let divisionDisplay = instance.division;
          
          if (instance.district && !isNaN(instance.district) && instance.district.toString().length < 10) {
            districtDisplay = await fetchDistrictName(instance.district);
          }
          
          if (instance.division && !isNaN(instance.division) && instance.division.toString().length < 10) {
            divisionDisplay = await fetchDivisionName(instance.division);
          }
          
          return {
            ...instance,
            district: districtDisplay,
            division: divisionDisplay,
            district_id: instance.district,
            division_id: instance.division
          };
        }
      })) : [];
      
      // Get summary data
      const summaryData = instancesRes.data.summary || {
        total: enhancedInstances.length,
        own_submissions: enhancedInstances.filter(i => i.is_own_submission).length,
        ulb_submissions: enhancedInstances.filter(i => !i.is_own_submission && i.submitted_by_role === 'ULB').length,
        dao_submissions: enhancedInstances.filter(i => !i.is_own_submission && (i.submitted_by_role === 'DAO' || i.submitted_by_role === 'DistrictAdmin')).length,
        actionable: enhancedInstances.filter(i => i.can_take_action).length
      };
      
      setInstances(enhancedInstances);
      setSummary(summaryData);
      
    } catch (error) {
      console.error('Failed to load form instances:', error);
      message.error('Failed to load form instances: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
      setLoadingFormData(false);
    }
  };

  const getViewTypeForNavigation = () => {
    if (userInfo.canViewAll) return 'admin';
    if (userInfo.isDivisionalOfficer) return 'division';
    if (userInfo.isDistrictAdmin) return 'district';
    return 'user';
  };

  const getViewContextForNavigation = () => {
    if (userInfo.isDivisionalOfficer) return userInfo.division_id || 'from-db';
    if (userInfo.isDistrictAdmin) return userInfo.district_id || 'from-db';
    if (!userInfo.canViewAll && userInfo.id) return userInfo.id;
    return null;
  };

  // IMPROVED: Get field label from schema with better matching
  const getFieldLabel = (fieldId) => {
    if (!fieldId) return fieldId;
    
    // Direct match in field mapping
    if (fieldMapping[fieldId]) {
      return fieldMapping[fieldId].label || fieldId;
    }
    
    // Try to find in schema fields by various matching methods
    const field = schemaFields.find(f => 
      f.field_id === fieldId || 
      f.name === fieldId ||
      f.id?.toString() === fieldId?.toString() ||
      (f.field_id && f.field_id.toLowerCase() === fieldId.toLowerCase()) ||
      (f.name && f.name.toLowerCase() === fieldId.toLowerCase())
    );
    
    if (field) {
      return field.label || fieldId;
    }
    
    // Try to match by removing non-alphanumeric characters
    const cleanFieldId = fieldId.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    const fieldByCleanId = schemaFields.find(f => {
      const fFieldId = (f.field_id || '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
      const fName = (f.name || '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
      return fFieldId === cleanFieldId || fName === cleanFieldId;
    });
    
    if (fieldByCleanId) {
      return fieldByCleanId.label || fieldId;
    }
    
    // Try to extract readable name from field ID
    if (fieldId && fieldId.includes('_')) {
      const parts = fieldId.split('_');
      // Skip the 'field' prefix if present
      const startIndex = parts[0] === 'field' ? 1 : 0;
      
      // Try to find meaningful part
      for (let i = parts.length - 1; i >= startIndex; i--) {
        const part = parts[i];
        if (part && part.length > 2 && /[a-zA-Z]/.test(part) && !/^\d+$/.test(part)) {
          // Capitalize first letter
          return part.charAt(0).toUpperCase() + part.slice(1);
        }
      }
      
      // If no meaningful part found, return the last part
      if (parts.length > startIndex) {
        const lastPart = parts[parts.length - 1];
        return lastPart.charAt(0).toUpperCase() + lastPart.slice(1);
      }
    }
    
    // If it looks like a database ID (just numbers), return "Field"
    if (/^\d+$/.test(fieldId)) {
      return `Field ${fieldId}`;
    }
    
    // Return formatted field ID as fallback
    return fieldId
      .replace(/_/g, ' ')
      .replace(/field/gi, '')
      .replace(/\s+/g, ' ')
      .trim() || fieldId;
  };

  // Get marathi field label
  const getMarathiLabel = (fieldId) => {
    if (!fieldId) return null;
    
    // Direct match in field mapping
    if (fieldMapping[fieldId] && fieldMapping[fieldId].marathi_label) {
      return fieldMapping[fieldId].marathi_label;
    }
    
    // Try to find in schema fields
    const field = schemaFields.find(f => 
      f.field_id === fieldId || 
      f.name === fieldId ||
      f.id?.toString() === fieldId?.toString()
    );
    
    if (field && field.marathi_label) {
      return field.marathi_label;
    }
    
    return null;
  };

  const handleTakeAction = (task) => {
    const canTakeAction = task.can_take_action || canUserTakeAction(task);
    if (!canTakeAction) {
      if (task.is_own_submission) {
        message.warning('You cannot take action on your own submission');
      } else {
        message.warning('You do not have permission to action this submission');
      }
      return;
    }
    navigate(`/workflow/action/${task.instance_id}`, { 
      state: { 
        task,
        returnTo: `/workflow/form-instances/${formId}`,
        formName 
      } 
    });
  };

  const viewWorkflowDetails = (task) => {
    navigate(`/workflow/details/${task.instance_id}`, { 
      state: { 
        task,
        returnTo: `/workflow/form-instances/${formId}`,
        formName 
      } 
    });
  };

  const viewFormData = (task, canTakeAction = false) => {
    navigate(`/workflow/form-data/${task.instance_id}`, { 
      state: { 
        task,
        canTakeAction,
        returnTo: `/workflow/form-instances/${formId}`,
        formName 
      } 
    });
  };

  // IMPROVED: Generate dynamic columns based on actual data keys
  const generateColumns = () => {
    // Always include submission ID first
    const columns = [
      {
        title: 'Submission ID',
        dataIndex: 'submission_id',
        key: 'submission_id',
        width: 120,
        fixed: isMobile ? false : 'left',
        render: (id, record) => (
          <div>
            <Tag color="blue" style={{ fontWeight: 600 }}>{id || 'N/A'}</Tag>
            <div style={{ marginTop: '4px' }}>
              {record.is_own_submission && (
                <Tag color="gold" size="small">Your Submission</Tag>
              )}
              {!record.is_own_submission && record.submitted_by_role === 'ULB' && (
                <Tag color="green" size="small">ULB Submission</Tag>
              )}
              {!record.is_own_submission && (record.submitted_by_role === 'DAO' || record.submitted_by_role === 'DistrictAdmin') && (
                <Tag color="cyan" size="small">DAO Submission</Tag>
              )}
            </div>
          </div>
        )
      }
    ];

    // Get all unique field keys from instances (excluding metadata)
    if (instances.length > 0) {
      const metadataKeys = [
        'instance_id', 'form_id', 'submission_id', 'current_stage_index', 'instance_status',
        'submitted_by_id', 'submitted_by', 'submitted_by_role', 'district', 'division',
        'district_id', 'division_id', 'created_at', 'started_at', 'completed_at',
        'current_stage', 'stage_name', 'stage_status', 'assigned_to_role', 'sla_deadline',
        'hours_remaining', 'is_own_submission', 'can_take_action', 'sla_status',
        'key', 'stage', 'sla', 'actions', 'deadline', 'stage_index', 'assigned_to_user',
        'actual_completion', 'comments', 'user_count', 'instance_count', 'district_count',
        'division_count', 'instance_statuses', 'first_submission', 'last_submission',
        'active_instances', 'pending_instances', 'completed_instances', 'escalated_instances',
        'own_submissions', 'ulb_submissions', 'dao_submissions', 'active_stages',
        'pending_stages', 'completed_stages', 'escalated_stages', 'breached_stages',
        'overall_status', 'form_name'
      ];

      // Collect all keys from all instances
      const allKeys = new Set();
      instances.forEach(instance => {
        Object.keys(instance).forEach(key => {
          // Skip metadata keys and empty values
          if (!metadataKeys.includes(key) && 
              !key.startsWith('_') && 
              instance[key] !== null && 
              instance[key] !== undefined) {
            allKeys.add(key);
          }
        });
      });

      console.log('📋 Dynamic column keys:', Array.from(allKeys));

      // Create columns for each unique key
      Array.from(allKeys).forEach(key => {
        // Get the label for this field
        const label = getFieldLabel(key);
        const marathiLabel = getMarathiLabel(key);
        
        // Create column title with bilingual support if available
        const title = marathiLabel && marathiLabel !== label ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontWeight: 600 }}>{label}</div>
            <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>{marathiLabel}</div>
          </div>
        ) : label;
        
        columns.push({
          title: title,
          dataIndex: key,
          key: key,
          width: 150,
          render: (value) => {
            if (value === null || value === undefined) {
              return <span style={{ color: '#999', fontStyle: 'italic' }}>-</span>;
            }
            
            // Handle different value types
            if (typeof value === 'object') {
              if (value && value.value !== undefined) {
                value = value.value;
              } else {
                return <span>{JSON.stringify(value).substring(0, 50)}...</span>;
              }
            }
            
            if (Array.isArray(value)) {
              return <span>{value.join(', ').substring(0, 50)}...</span>;
            }
            
            // Truncate long strings
            if (typeof value === 'string' && value.length > 50) {
              return <Tooltip title={value}>{value.substring(0, 50)}...</Tooltip>;
            }
            
            return <span>{String(value)}</span>;
          }
        });
      });
    }

    // Add location columns
    columns.push({
      title: <div><EnvironmentOutlined /> District</div>,
      dataIndex: 'district',
      key: 'district',
      width: 120,
      render: (district, record) => district ? (
        <Tag color="cyan">{district}</Tag>
      ) : record.district_id ? (
        <Tag color="cyan">ID: {record.district_id}</Tag>
      ) : <span style={{ color: '#999' }}>-</span>
    });

    if (initialViewType === 'admin' || initialViewType === 'division' || userInfo.canViewAll || userInfo.isDivisionalOfficer) {
      columns.push({
        title: <div><PartitionOutlined /> Division</div>,
        dataIndex: 'division',
        key: 'division',
        width: 120,
        render: (division, record) => division ? (
          <Tag color="geekblue">{division}</Tag>
        ) : record.division_id ? (
          <Tag color="geekblue">ID: {record.division_id}</Tag>
        ) : <span style={{ color: '#999' }}>-</span>
      });
    }

    // Add submitted by column
    columns.push({
      title: 'Submitted By',
      dataIndex: 'submitted_by',
      key: 'submitted_by',
      width: 150,
      render: (text, record) => (
        <div>
          <div>{text || 'Unknown'}</div>
          <Tag color={record.submitted_by_role === 'ULB' ? 'green' : 
                     record.submitted_by_role === 'DAO' ? 'cyan' : 
                     record.submitted_by_role === 'DIVISIONAL_OFFICER' ? 'orange' : 'purple'} 
               style={{ fontSize: '10px', marginTop: '2px' }}>
            {record.submitted_by_role || 'ULB'}
          </Tag>
          {record.submitted_by_id == userInfo.id && (
            <Tag color="gold" style={{ fontSize: '10px', marginLeft: '4px' }}>You</Tag>
          )}
        </div>
      )
    });

    // Add stage column
    columns.push({
      title: 'Stage',
      key: 'stage',
      width: 120,
      render: (_, record) => (
        <div>
          <Tag color="blue" style={{ fontWeight: 500, padding: '2px 8px', borderRadius: '6px' }}>
            {record.stage_name || 'Unknown'}
          </Tag>
          <div style={{ marginTop: '4px' }}>
            <Tag 
              color={
                record.stage_status === 'in_progress' ? 'processing' :
                record.stage_status === 'pending' ? 'warning' :
                record.stage_status === 'approved' ? 'success' :
                record.stage_status === 'rejected' ? 'error' :
                record.stage_status === 'escalated' ? 'red' : 'default'
              }
              style={{ fontSize: '10px' }}
            >
              {record.stage_status?.replace('_', ' ') || 'pending'}
            </Tag>
          </div>
        </div>
      )
    });

    // Add deadline column
    columns.push({
      title: 'Deadline',
      key: 'deadline',
      width: 120,
      render: (_, record) => (
        <div>
          {record.sla_deadline ? (
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <CalendarOutlined style={{ color: '#666', fontSize: '12px' }} />
                <span>{new Date(record.sla_deadline).toLocaleDateString()}</span>
              </div>
              <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
                {record.hours_remaining < 0 ?
                  `${Math.abs(record.hours_remaining)}h overdue` :
                  `${record.hours_remaining}h left`}
              </div>
            </div>
          ) : (
            <div style={{ color: '#999', fontStyle: 'italic' }}>No deadline</div>
          )}
        </div>
      )
    });

    // Add SLA status column
    columns.push({
      title: 'SLA Status',
      key: 'sla',
      width: 100,
      render: (_, record) => {
        if (record.stage_status === 'escalated') {
          return (
            <Tag color="red" icon={<AlertOutlined />} style={{ fontWeight: 500, padding: '2px 8px', borderRadius: '6px' }}>
              Escalated
            </Tag>
          );
        }
        if (!record.sla_deadline) return (
          <Tag style={{ fontWeight: 500, padding: '2px 8px', borderRadius: '6px' }}>
            No SLA
          </Tag>
        );
        if (record.hours_remaining < 0) return (
          <Tag color="red" style={{ fontWeight: 500, padding: '2px 8px', borderRadius: '6px' }}>
            Breached
          </Tag>
        );
        if (record.hours_remaining < 24) return (
          <Tag color="orange" style={{ fontWeight: 500, padding: '2px 8px', borderRadius: '6px' }}>
            Due soon
          </Tag>
        );
        return (
          <Tag color="green" style={{ fontWeight: 500, padding: '2px 8px', borderRadius: '6px' }}>
            On track
          </Tag>
        );
      }
    });

    // Add actions column
    columns.push({
      title: 'Actions',
      key: 'actions',
      width: 280,
      fixed: isMobile ? false : 'right',
      render: (_, record) => {
        const canTakeAction = record.can_take_action || canUserTakeAction(record);
        const canView = canUserViewSubmission(record);
        
        if (!canView) {
          return (
            <Tooltip title="You don't have permission to view this submission">
              <Button type="dashed" size="small" disabled>
                No Access
              </Button>
            </Tooltip>
          );
        }
        
        return (
          <Space size="small">
            <Tooltip title="View Full Form Data">
              <Button
                icon={<DatabaseOutlined />}
                size="small"
                onClick={() => viewFormData(record, canTakeAction)}
                style={{
                  background: '#f6ffed',
                  borderColor: '#b7eb8f',
                  color: '#52c41a'
                }}
              />
            </Tooltip>
            
            <Tooltip title="View Workflow Details">
              <Button
                icon={<EyeOutlined />}
                size="small"
                onClick={() => viewWorkflowDetails(record)}
                style={{
                  background: '#f0f7ff',
                  borderColor: '#91d5ff',
                  color: '#1890ff'
                }}
              />
            </Tooltip>
            
            {canTakeAction ? (
              <Tooltip title="Take Action">
                <Button
                  type="primary"
                  icon={<SendOutlined />}
                  size="small"
                  onClick={() => handleTakeAction(record)}
                  style={{
                    background: 'linear-gradient(135deg, #52c41a 0%, #73d13d 100%)',
                    borderColor: '#52c41a'
                  }}
                >
                  Take Action
                </Button>
              </Tooltip>
            ) : (
              <Tooltip title={
                record.stage_status !== 'in_progress' 
                  ? 'Stage not in progress'
                  : record.is_own_submission
                    ? 'You cannot take action on your own submission'
                    : 'You do not have permission to action this submission'
              }>
                <Button type="dashed" size="small" disabled>
                  View Only
                </Button>
              </Tooltip>
            )}
          </Space>
        );
      }
    });

    return columns;
  };

  const selectedCount = selectedRowKeys.length;

  const getActionableSelectedInstances = () => {
    return instances.filter(
      instance => selectedRowKeys.includes(instance.instance_id) && 
                 (instance.can_take_action || canUserTakeAction(instance))
    );
  };

  const actionableSelectedInstances = getActionableSelectedInstances();
  const actionableSelectedCount = actionableSelectedInstances.length;

  const rowSelection = {
    selectedRowKeys,
    onChange: setSelectedRowKeys,
    getCheckboxProps: (record) => ({
      disabled: !record.can_take_action || !canUserViewSubmission(record),
      name: record.instance_id,
    })
  };

  const clearSelections = () => {
    setSelectedRowKeys([]);
  };

  const openBulkActionModal = (actionType) => {
    const selectedInstances = instances.filter(
      instance => selectedRowKeys.includes(instance.instance_id)
    );
    
    const actionableInstances = selectedInstances.filter(instance => 
      instance.can_take_action || canUserTakeAction(instance)
    );
    
    if (actionableInstances.length === 0) {
      message.warning('None of the selected submissions are actionable.');
      return;
    }
    
    if (actionableInstances.length < selectedInstances.length) {
      message.warning(`${selectedInstances.length - actionableInstances.length} submission(s) cannot be actioned due to permission restrictions.`);
    }
    
    setBulkActionModal({
      visible: true,
      selectedCount: actionableInstances.length,
      selectedInstances: actionableInstances,
      action: actionType
    });
    
    bulkActionForm.resetFields();
  };

  const handleBulkActionSubmit = async (values) => {
    try {
      const { selectedInstances, action } = bulkActionModal;
      
      if (selectedInstances.length === 0) {
        message.error('No instances selected for bulk action');
        return;
      }

      const payload = {
        instance_ids: selectedInstances.map(instance => instance.instance_id),
        action: action,
        comments: values.comments,
        performed_by_name: sessionStorage.getItem('userName') || userInfo.name,
        performed_by_id: userInfo.id,
        performed_by_role: userInfo.roleType
      };

      message.loading({ content: `Processing bulk ${action} action...`, key: 'bulkAction' });

      const response = await api.post('/workflow/bulk-action', payload);
      
      if (response.data.success) {
        const { successful, failed } = response.data.data;
        
        if (failed.length > 0) {
          message.warning({
            content: `${successful.length} successful, ${failed.length} failed.`,
            key: 'bulkAction',
            duration: 5
          });
        } else {
          message.success({
            content: `Successfully performed '${action}' on ${successful.length} submission(s)`,
            key: 'bulkAction',
            duration: 5
          });
        }
        
        setBulkActionModal({ visible: false, selectedCount: 0, selectedInstances: [], action: null });
        clearSelections();
        loadFormInstances();
        
        // नोटिफिकेशन ट्रिगर करा
        sessionStorage.setItem('workflow_updated', Date.now().toString());
        window.dispatchEvent(new CustomEvent('workflow-updated'));
      } else {
        message.error({ 
          content: 'Bulk action failed: ' + (response.data.message || 'Unknown error'), 
          key: 'bulkAction' 
        });
      }
    } catch (error) {
      console.error('Bulk action error:', error);
      message.error({ 
        content: 'Failed to submit bulk action: ' + (error.response?.data?.message || error.message), 
        key: 'bulkAction' 
      });
    }
  };

  const bulkActionItems = [
    {
      key: 'approve',
      icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
      label: 'Approve Selected',
      onClick: () => openBulkActionModal('approve'),
      disabled: actionableSelectedCount === 0
    },
    {
      key: 'reject',
      icon: <StopOutlined style={{ color: '#f5222d' }} />,
      label: 'Reject Selected',
      onClick: () => openBulkActionModal('reject'),
      disabled: actionableSelectedCount === 0
    },
    {
      key: 'return',
      icon: <ArrowRightOutlined style={{ color: '#fa8c16' }} />,
      label: 'Return for Revision',
      onClick: () => openBulkActionModal('return'),
      disabled: actionableSelectedCount === 0
    },
    {
      key: 'escalate',
      icon: <RiseOutlined style={{ color: '#f5222d' }} />,
      label: 'Escalate Selected',
      onClick: () => openBulkActionModal('escalate'),
      disabled: actionableSelectedCount === 0
    },
    { type: 'divider' },
    {
      key: 'clear',
      icon: <CloseOutlined />,
      label: 'Clear Selection',
      onClick: clearSelections,
      disabled: selectedCount === 0
    }
  ];

  const getViewTypeLabel = () => {
    switch (initialViewType) {
      case 'admin': return 'All Submissions';
      case 'division': return `${initialViewContext} Division - All Submissions`;
      case 'district': return `${initialViewContext} District - All Submissions`;
      case 'user': return 'Your Submissions Only';
      default: return 'Submissions';
    }
  };

  const renderBulkActionModal = () => {
    const actionLabels = {
      'approve': 'Approve',
      'reject': 'Reject',
      'return': 'Return for Revision',
      'escalate': 'Escalate'
    };

    const actionColors = {
      'approve': '#52c41a',
      'reject': '#f5222d',
      'return': '#fa8c16',
      'escalate': '#f5222d'
    };

    return (
      <Modal
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              background: `linear-gradient(135deg, ${actionColors[bulkActionModal.action] || '#1890ff'} 0%, ${actionColors[bulkActionModal.action] || '#40a9ff'} 100%)`,
              width: '40px',
              height: '40px',
              borderRadius: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {bulkActionModal.action === 'approve' && <CheckCircleOutlined style={{ color: 'white', fontSize: '18px' }} />}
              {bulkActionModal.action === 'reject' && <StopOutlined style={{ color: 'white', fontSize: '18px' }} />}
              {bulkActionModal.action === 'return' && <ArrowRightOutlined style={{ color: 'white', fontSize: '18px' }} />}
              {bulkActionModal.action === 'escalate' && <RiseOutlined style={{ color: 'white', fontSize: '18px' }} />}
            </div>
            <div>
              <div style={{ fontWeight: 700, fontSize: '18px', color: '#032452' }}>
                Bulk {actionLabels[bulkActionModal.action] || 'Action'}: {formName}
              </div>
              <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>
                {bulkActionModal.selectedCount} submission(s) selected
              </div>
            </div>
          </div>
        }
        open={bulkActionModal.visible}
        onCancel={() => setBulkActionModal({ visible: false, selectedCount: 0, selectedInstances: [], action: null })}
        footer={null}
        width={isMobile ? '90%' : 600}
        style={{ top: '20%' }}
        maskClosable={false}
      >
        <Alert
          style={{ marginBottom: '20px' }}
          message={`Perform Bulk ${actionLabels[bulkActionModal.action] || 'Action'}`}
          description={`You are about to ${bulkActionModal.action} ${bulkActionModal.selectedCount} submission(s).`}
          type="info"
          showIcon
        />
        
        <Form form={bulkActionForm} layout="vertical" onFinish={handleBulkActionSubmit}>
          <Form.Item
            name="comments"
            label="Comments & Remarks"
            rules={[{ required: true, message: 'Please enter comments for this bulk action' }]}
          >
            <Input.TextArea
              rows={4}
              placeholder={`Enter your comments or reasons for this bulk ${bulkActionModal.action} action...`}
              style={{ borderRadius: '8px' }}
            />
          </Form.Item>
          
          <Form.Item>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
              <Button 
                onClick={() => setBulkActionModal({ visible: false, selectedCount: 0, selectedInstances: [], action: null })}
                style={{ borderRadius: '8px' }}
              >
                Cancel
              </Button>
              <Button 
                type="primary" 
                htmlType="submit"
                style={{
                  background: `linear-gradient(135deg, ${actionColors[bulkActionModal.action] || '#52c41a'} 0%, ${actionColors[bulkActionModal.action] || '#73d13d'} 100%)`,
                  borderColor: actionColors[bulkActionModal.action] || '#52c41a',
                  borderRadius: '8px',
                  fontWeight: 600
                }}
              >
                <CheckCircleOutlined /> Submit Bulk Action
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  // Load data on mount
  useEffect(() => {
    if (formId) {
      loadFormSchema();
      loadFormInstances();
    }
  }, [formId]);

  const isLoading = loading || loadingFormData || loadingSchema;

  // Responsive column spans for equal card sizing
  const getCardSpan = () => {
    if (isMobile) return 24;
    if (screens.sm && !screens.md) return 12;
    if (screens.md && !screens.lg) return 8;
    if (screens.lg && !screens.xl) return 6;
    return 4;
  };

  const cardSpan = getCardSpan();

  return (
    <>
      <Navbar onMenuClick={() => setSbCollapsed(false)} />
      {/* <Sidebar collapsed={sbCollapsed} setCollapsed={setSbCollapsed} /> */}

      {isMobile && !sbCollapsed && (
        <div 
          className="sidebar-overlay"
          onClick={() => setSbCollapsed(true)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999,
          }}
        />
      )}

      <div 
        className="form-instances-view"
        style={{
          marginLeft: sidebarWidth,
          transition: "all 0.3s ease",
          minHeight: '100vh',
          background: '#f5f7fa',
          width: mainContentWidth,
          position: 'relative'
        }}
      >
        <div style={{
          minHeight: '100vh',
          overflowY: 'auto',
          overflowX: 'hidden',
          paddingTop: '80px',
          paddingLeft: isMobile ? 12 : 20,
          paddingRight: isMobile ? 12 : 20,
          paddingBottom: 20
        }}>
          {/* Header */}
          <div style={{ 
            marginBottom: '24px',
            background: '#fff',
            borderRadius: '12px',
            padding: '24px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            border: '1px solid #f0f0f0'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                <Button
                  icon={<ArrowLeftOutlined />}
                  onClick={() => navigate('/workflow')}
                  style={{ marginRight: '8px', borderRadius: '8px' }}
                />
                <div style={{
                  background: 'linear-gradient(135deg, #1890ff 0%, #40a9ff 100%)',
                  width: '40px',
                  height: '40px',
                  borderRadius: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <BarsOutlined style={{ color: 'white', fontSize: '18px' }} />
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: '18px', color: '#032452' }}>
                    {formName || 'Form Submissions'} - Form Data
                  </div>
                  <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>
                    {getViewTypeLabel()} • {instances.length || 0} submissions
                    {schemaFields.length > 0 && (
                      <Tag color="purple" style={{ marginLeft: '8px' }}>
                        {schemaFields.length} Fields
                      </Tag>
                    )}
                    <Tag color={initialViewType === 'admin' ? 'red' : 
                               initialViewType === 'division' ? 'orange' :
                               initialViewType === 'district' ? 'cyan' : 'green'} 
                         style={{ marginLeft: '8px' }}>
                      {initialViewType === 'admin' && <CrownOutlined />}
                      {initialViewType === 'division' && <PartitionOutlined />}
                      {initialViewType === 'district' && <EnvironmentOutlined />}
                      {initialViewType === 'user' && <UserOutlined />}
                      {initialViewType === 'admin' ? ' ADMIN VIEW' : 
                       initialViewType === 'division' ? ' DIVISION VIEW' :
                       initialViewType === 'district' ? ' DISTRICT VIEW' : ' YOUR VIEW'}
                    </Tag>
                  </div>
                  <div style={{ fontSize: '12px', marginTop: '4px' }}>
                    <Space size="small" wrap>
                      <Badge color="gold" text={`Own: ${summary.own_submissions}`} />
                      <Badge color="green" text={`ULB: ${summary.ulb_submissions}`} />
                      <Badge color="cyan" text={`DAO: ${summary.dao_submissions}`} />
                      <Badge color="blue" text={`Actionable: ${summary.actionable}`} />
                    </Space>
                  </div>
                </div>
              </div>
              <Space wrap>
                {/* ===== NEW: Auto-refresh indicator ===== */}
                {autoRefreshEnabled && (
                  <Tooltip title={`Auto-refresh in ${countdown}s`}>
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '4px',
                      padding: '4px 12px',
                      background: '#e6f7ff',
                      borderRadius: '20px',
                      border: '1px solid #91d5ff',
                      fontSize: '12px',
                      color: '#0050b3'
                    }}>
                      <ClockCircleOutlined /> {countdown}s
                    </div>
                  </Tooltip>
                )}
                
                {/* ===== NEW: Force Refresh Button ===== */}
                <Tooltip title="Force Refresh Now">
                  <Button
                    icon={<ThunderboltOutlined />}
                    onClick={forceRefresh}
                    loading={loading}
                    style={{
                      background: 'linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)',
                      borderColor: '#ff4d4f',
                      color: 'white',
                      borderRadius: '8px'
                    }}
                  >
                    Force Refresh
                  </Button>
                </Tooltip>
                
                <Tooltip title="Refresh Data">
                  <Button
                    icon={<ReloadOutlined spin={isLoading} />}
                    onClick={() => {
                      loadFormSchema();
                      loadFormInstances();
                    }}
                    style={{ borderRadius: '8px' }}
                  />
                </Tooltip>
                
                {actionableSelectedCount > 0 && (
                  <Dropdown 
                    menu={{ items: bulkActionItems }} 
                    placement="bottomRight" 
                    trigger={['click']}
                  >
                    <Button 
                      type="primary"
                      style={{
                        background: 'linear-gradient(135deg, #722ed1 0%, #9254de 100%)',
                        borderColor: '#722ed1',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        borderRadius: '8px'
                      }}
                    >
                      Bulk Actions ({actionableSelectedCount} actionable) <DownOutlined />
                    </Button>
                  </Dropdown>
                )}
              </Space>
            </div>
            
            {/* ===== NEW: Last updated indicator ===== */}
            <div style={{ 
              marginTop: '12px', 
              fontSize: '11px', 
              color: '#999',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: '8px'
            }}>
              <span>Last updated: {new Date(lastUpdated).toLocaleTimeString()}</span>
              <Button 
                type="link" 
                size="small" 
                onClick={() => setAutoRefreshEnabled(!autoRefreshEnabled)}
                style={{ padding: 0, height: 'auto' }}
              >
                {autoRefreshEnabled ? 'Disable Auto-refresh' : 'Enable Auto-refresh'}
              </Button>
            </div>
          </div>

          {isLoading ? (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '50vh' }}>
              <Spin size="large" />
              <div style={{ marginTop: '16px', color: '#666' }}>
                Loading form data for {formName}...
              </div>
            </div>
          ) : instances.length > 0 ? (
            <>
              {/* Schema Info Alert */}
              {schemaFields.length > 0 && (
                <Alert
                  style={{ marginBottom: '16px' }}
                  message={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <span>
                        <DatabaseOutlined /> Found {schemaFields.length} form fields
                      </span>
                    </div>
                  }
                  type="info"
                  showIcon
                />
              )}

              {/* Selection Alert */}
              {selectedCount > 0 && (
                <Alert
                  style={{ marginBottom: '16px' }}
                  message={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
                      <span>
                        <CheckCircleOutlined style={{ color: '#52c41a' }} /> {selectedCount} submission(s) selected
                        {selectedCount > actionableSelectedCount && (
                          <span style={{ marginLeft: '8px', color: '#fa8c16' }}>
                            ({selectedCount - actionableSelectedCount} not actionable)
                          </span>
                        )}
                      </span>
                      <Space wrap>
                        <Button size="small" onClick={clearSelections}>
                          Clear Selection
                        </Button>
                        {actionableSelectedCount > 0 && (
                          <Dropdown 
                            menu={{ items: bulkActionItems }} 
                            placement="bottomRight" 
                            trigger={['click']}
                          >
                            <Button 
                              type="primary" 
                              size="small"
                              style={{
                                background: 'linear-gradient(135deg, #722ed1 0%, #9254de 100%)',
                                borderColor: '#722ed1',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                              }}
                            >
                              Bulk Actions ({actionableSelectedCount}) <DownOutlined />
                            </Button>
                          </Dropdown>
                        )}
                      </Space>
                    </div>
                  }
                  type="info"
                  showIcon={false}
                />
              )}

              {/* Data Table */}
              <Card 
                className="table-card"
                style={{ 
                  borderRadius: '12px',
                  border: '1px solid #f0f0f0',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.05)'
                }}
                bodyStyle={{ padding: 0 }}
              >
                <Table
                  columns={generateColumns()}
                  dataSource={instances}
                  rowKey="instance_id"
                  rowSelection={userInfo.canActionSubordinate || userInfo.canActionOwn ? rowSelection : undefined}
                  pagination={{ 
                    pageSize: 20,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total) => `Total ${total} submissions`
                  }}
                  scroll={{ x: 'max-content', y: 'calc(80vh - 350px)' }}
                  size="middle"
                  className="enhanced-table"
                  loading={isLoading}
                />
              </Card>
            </>
          ) : (
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              justifyContent: 'center', 
              height: '50vh' 
            }}>
              <FileDoneOutlined style={{ fontSize: '64px', color: '#d9d9d9', marginBottom: '16px' }} />
              <Title level={3} style={{ color: '#666', marginBottom: '8px' }}>No submissions found</Title>
              <Text type="secondary">This form has no active workflow instances.</Text>
            </div>
          )}
        </div>
      </div>

      {/* Bulk Action Modal */}
      {renderBulkActionModal()}

      <style jsx="true">{`
        /* ====== GLOBAL STYLES ====== */
        * {
          box-sizing: border-box;
        }

        body {
          margin: 0;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
          background: #f5f7fa;
        }

        /* ====== SIDEBAR OVERLAY ====== */
        .sidebar-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 999;
        }

        /* ====== MAIN CONTAINER ====== */
        .form-instances-view {
          min-height: 100vh;
          background: #f5f7fa;
          transition: margin-left 0.3s ease, width 0.3s ease;
        }

        /* ====== HEADER SECTION ====== */
        .form-instances-view .ant-card:first-child {
          animation: slideDown 0.3s ease;
          border-radius: 16px !important;
          overflow: hidden;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* ====== TABLE STYLES ====== */
        .enhanced-table {
          border-radius: 16px !important;
          overflow: hidden;
        }

        .enhanced-table .ant-table {
          background: white;
        }

        .enhanced-table .ant-table-thead > tr > th {
          background: #f8fafc !important;
          font-weight: 700 !important;
          color: #1e293b !important;
          padding: 16px 12px !important;
          border-bottom: 2px solid #e2e8f0 !important;
          font-size: 13px !important;
          white-space: nowrap;
        }

        .enhanced-table .ant-table-tbody > tr > td {
          padding: 16px 12px !important;
          border-bottom: 1px solid #f1f5f9 !important;
          font-size: 13px !important;
        }

        .enhanced-table .ant-table-tbody > tr:hover > td {
          background: #f1f5f9 !important;
        }

        /* ====== TAG STYLES ====== */
        .enhanced-table .ant-tag {
          border-radius: 20px !important;
          padding: 4px 12px !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          border: none !important;
          margin: 0 4px 4px 0 !important;
          line-height: 1.5;
        }

        .ant-tag-blue {
          background: #e0f2fe !important;
          color: #0284c7 !important;
        }

        .ant-tag-green {
          background: #dcfce7 !important;
          color: #16a34a !important;
        }

        .ant-tag-gold {
          background: #fef9c3 !important;
          color: #ca8a04 !important;
        }

        .ant-tag-cyan {
          background: #cffafe !important;
          color: #0891b2 !important;
        }

        .ant-tag-purple {
          background: #f3e8ff !important;
          color: #9333ea !important;
        }

        .ant-tag-red {
          background: #fee2e2 !important;
          color: #dc2626 !important;
        }

        .ant-tag-orange {
          background: #ffedd5 !important;
          color: #ea580c !important;
        }

        .ant-tag-geekblue {
          background: #e0f2fe !important;
          color: #0369a1 !important;
        }

        /* ====== BUTTON STYLES ====== */
        .enhanced-table .ant-btn {
          border-radius: 8px !important;
          font-weight: 600 !important;
          transition: all 0.2s ease !important;
          height: 32px !important;
          padding: 0 12px !important;
          font-size: 12px !important;
        }

        .enhanced-table .ant-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }

        .enhanced-table .ant-btn-sm {
          height: 28px !important;
          padding: 0 10px !important;
          font-size: 11px !important;
        }

        .enhanced-table .ant-btn-primary {
          background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
          border: none;
          box-shadow: 0 2px 6px rgba(37, 99, 235, 0.3);
        }

        .enhanced-table .ant-btn-primary:hover {
          background: linear-gradient(135deg, #1d4ed8 0%, #2563eb 100%);
        }

        /* ====== FILTER SECTION ====== */
        .ant-input-affix-wrapper,
        .ant-select-selector {
          border-radius: 12px !important;
          border: 1px solid #e2e8f0 !important;
          transition: all 0.2s ease !important;
          height: 42px !important;
          padding: 0 14px !important;
        }

        .ant-input-affix-wrapper:hover,
        .ant-select-selector:hover {
          border-color: #3b82f6 !important;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
        }

        .ant-input-affix-wrapper-focused,
        .ant-select-focused .ant-select-selector {
          border-color: #3b82f6 !important;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2) !important;
        }

        /* ====== PAGINATION ====== */
        .enhanced-table .ant-pagination {
          margin: 24px 24px !important;
        }

        .enhanced-table .ant-pagination-item {
          border-radius: 8px !important;
          font-weight: 600 !important;
          border: 1px solid #e2e8f0 !important;
        }

        .enhanced-table .ant-pagination-item-active {
          background: #3b82f6 !important;
          border-color: #3b82f6 !important;
        }

        .enhanced-table .ant-pagination-item-active a {
          color: white !important;
        }

        .enhanced-table .ant-pagination-item:hover {
          border-color: #3b82f6 !important;
        }

        /* ====== ALERT STYLES ====== */
        .ant-alert {
          border-radius: 12px !important;
          border: none !important;
          padding: 16px 20px !important;
        }

        .ant-alert-info {
          background: #e0f2fe !important;
          color: #0369a1 !important;
        }

        /* ====== BADGE STYLES ====== */
        .ant-badge-status-text {
          font-size: 12px !important;
          font-weight: 500 !important;
          color: #64748b !important;
        }

        /* ====== DROPDOWN STYLES ====== */
        .ant-dropdown-menu {
          border-radius: 12px !important;
          padding: 8px !important;
          box-shadow: 0 12px 24px -8px rgba(0,0,0,0.2) !important;
        }

        .ant-dropdown-menu-item {
          border-radius: 8px !important;
          padding: 10px 16px !important;
          font-weight: 500 !important;
        }

        .ant-dropdown-menu-item:hover {
          background: #f1f5f9 !important;
        }

        /* ====== EMPTY STATE ====== */
        .empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 60px 20px;
          background: white;
          border-radius: 16px;
          text-align: center;
        }

        .empty-state .anticon {
          font-size: 64px;
          color: #cbd5e1;
          margin-bottom: 16px;
        }

        .empty-state h3 {
          font-size: 20px;
          font-weight: 600;
          color: #334155;
          margin-bottom: 8px;
        }

        .empty-state p {
          font-size: 14px;
          color: #94a3b8;
          max-width: 400px;
          margin: 0 auto;
        }

        /* ====== SCROLLBAR STYLING ====== */
        ::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        ::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 4px;
        }

        ::-webkit-scrollbar-thumb {
          background: #94a3b8;
          border-radius: 4px;
        }

        ::-webkit-scrollbar-thumb:hover {
          background: #64748b;
        }

        /* ====== RESPONSIVE DESIGN ====== */
        @media (max-width: 768px) {
          .enhanced-table .ant-table {
            font-size: 12px;
          }
          
          .enhanced-table .ant-table-thead > tr > th,
          .enhanced-table .ant-table-tbody > tr > td {
            padding: 12px 8px !important;
          }
          
          .enhanced-table .ant-btn-sm {
            height: 24px !important;
            padding: 0 6px !important;
            font-size: 10px !important;
          }
          
          .enhanced-table .ant-tag {
            padding: 2px 8px !important;
            font-size: 10px !important;
          }

          .ant-input-affix-wrapper,
          .ant-select-selector {
            height: 38px !important;
          }
        }

        /* ====== PRINT STYLES ====== */
        @media print {
          .form-instances-view {
            margin-left: 0 !important;
            width: 100% !important;
            padding: 20px !important;
          }
          
          .ant-btn,
          .ant-select,
          .ant-input-affix-wrapper {
            display: none !important;
          }
        }
      `}</style>
    </>
  );
};

export default FormInstancesView;